<template>
    <a
        v-if="isSubdomain"
        :href="`${$page.props.appUrl}/formations/${formation.slug}`"
        class="group flex flex-col space-y-6 rounded-md border bg-white p-6 shadow"
        :class="[formation.promoted ? 'border-t-4 border-green-600 hover:border-t-4 hover:border-green-600' : '']"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div>
            <h2 class="text-2xl font-bold leading-tight group-hover:underline">{{ title }}</h2>
            <p class="font-semibold">{{ formation.company.name }}</p>
        </div>

        <div class="flex flex-col space-y-1 text-gray-600">
            <div class="flex items-center space-x-2">
                <IconMapPin :size="16" class="text-gray-500" />
                <span class="font-medium">{{ formation.city }}</span>
            </div>
        </div>

        <div class="flex flex-1 items-end justify-center">
            <img loading="lazy" :src="formation.company.logo" alt="" class="hidden h-32 w-64 object-contain md:block" />
        </div>
    </a>

    <a
        v-else
        :href="`/formations/${formation.slug}`"
        class="group flex flex-col space-y-6 rounded-md border bg-white p-6 shadow"
        :class="[formation.promoted ? 'border-t-4 border-green-600 hover:border-t-4 hover:border-green-600' : '']"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div>
            <h2 class="text-2xl font-bold leading-tight group-hover:underline">{{ title }}</h2>
            <p class="font-semibold">{{ formation.company_name }}</p>
        </div>

        <div class="flex flex-col space-y-1 text-gray-600">
            <div class="flex items-center space-x-2">
                <IconMapPin :size="16" class="text-gray-500" />
                <span class="font-medium">{{ formation.city }}</span>
            </div>
        </div>

        <div class="flex flex-1 items-end justify-center">
            <img loading="lazy" :src="formation.company_logo" alt="" class="hidden h-32 w-64 object-contain md:block" />
        </div>
    </a>
</template>

<script setup>
    import { usePage } from '@inertiajs/inertia-vue3';
    import { IconMapPin } from '@tabler/icons-vue';
    import { computed } from 'vue';

    const props = defineProps({
        formation: Object,
        isSubdomain: {
            type: Boolean,
            default: false,
        },
    });

    const title = computed(() => {
        return usePage().props.value.locale == 'fr' ? props.formation?.title_fr : props.formation?.title_en;
    });
</script>
